import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = { key: 0 };
import LoadingAnimation from "src/shared/v-components/loading-animation/LoadingAnimation.vue";
import Button from "src/shared/v-components/ui/Button.vue";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'NewChildComponentAddButton',
    props: {
        isPending: { type: Boolean },
        isSuccessful: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const isAnimating = computed(() => props.isPending || props.isSuccessful);
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(Button, {
                disabled: isAnimating.value,
                class: "button--checkmark-animation"
            }, {
                default: _withCtx(() => [
                    (!isAnimating.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_1, "Add"))
                        : (_openBlock(), _createBlock(LoadingAnimation, {
                            key: 1,
                            "show-loading-animation": _ctx.isPending,
                            "show-success-animation": _ctx.isSuccessful,
                            color: 'white'
                        }, null, 8 /* PROPS */, ["show-loading-animation", "show-success-animation"]))
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["disabled"]));
        };
    }
});
